// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RtX2","content":"styles_content__KmGxp"};